import { useState } from 'react';

export function VendingProductImage({ src, name }: { src: string; name: string }) {
  const [failed, setFailed] = useState(false);
  return failed ? <span aria-label="No product image">—</span> : (
    <img src={src} alt={name} width={48} height={48} loading="lazy" referrerPolicy="no-referrer"
      onError={() => setFailed(true)} style={{ objectFit: 'contain', borderRadius: 3 }} />
  );
}
